var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cs from 'classnames';
import ArcoButton from '@arco-design/web-react/es/Button';
import { useConfigContext } from '../config-provider';
export var ButtonTextType;
(function (ButtonTextType) {
    ButtonTextType["Default"] = "default";
    ButtonTextType["Text00"] = "p0-proxima-regular";
    ButtonTextType["Text00b"] = "p0-proxima-semibold";
    ButtonTextType["Text01"] = "p1-proxima-regular";
    ButtonTextType["Text01b"] = "p1-proxima-semibold";
    ButtonTextType["Text02"] = "p2-proxima-regular";
    ButtonTextType["Text02b"] = "p2-proxima-semibold";
    ButtonTextType["Text03"] = "p3-proxima-regular";
    ButtonTextType["Text03b"] = "p3-proxima-semibold";
    ButtonTextType["Text04"] = "p4-proxima-regular";
    ButtonTextType["Text04b"] = "p4-proxima-semibold";
})(ButtonTextType || (ButtonTextType = {}));
var Button = function (props, ref) {
    var className = props.className, type = props.type, textType = props.textType, rest = __rest(props, ["className", "type", "textType"]);
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-btn";
    var buttonClassName = cs(className, prefixCls);
    if (textType && textType !== ButtonTextType.Default) {
        // custom text class
        var buttonTextCls = prefixCls + "-text-" + textType;
        buttonClassName = cs(buttonClassName, buttonTextCls);
    }
    if (type) {
        // add custom type class
        buttonClassName = cs(buttonClassName, prefixCls + "-type-" + type);
    }
    return (React.createElement(ArcoButton, __assign({ ref: ref }, rest, { className: buttonClassName, type: type }), props.children));
};
var ForwardRefButton = React.forwardRef(Button);
var ButtonComponent = ForwardRefButton;
ButtonComponent.Group = ArcoButton.Group;
ButtonComponent.displayName = 'Button';
export default ButtonComponent;
//# sourceMappingURL=index.js.map